module.exports = __webpack_public_path__ + "img/3.53180183.png";